import { Lang } from '@/i18n/types'

export function replaceLang({ pathname, locale }: { pathname: string; locale: Lang }) {
  const route = pathname.substring(4)
  const queryString = typeof document === 'undefined' ? '' : document.location.search.substring(1)
  return `/${locale}/${route}${queryString ? `?${queryString}` : ''}`
}
